<template>
  <a-card v-if="getScreen">
    <span slot="title">Credit Card Claim Ticket Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Usage" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps" :disabled="disabledActionBtnSts"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next" :disabled="disabledActionBtnSts">Next</a-button>
        <a-button
          v-if="current == steps.length - 1"
          type="default"
          :loading="btnLoading"
          @click="validate"
          :disabled="dataList.length < 1 || disabledActionBtnSts"
        >{{ status === false ? "Save Draft" : "Save" }}</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :span="leftcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column nowrap">
        <span slot="title">Credit Card Claim Ticket Form</span>
        <a-steps :current="current" status="process">
          <a-step title="Information" />
          <a-step title="Usage" />
          <a-step title="Approval" />
        </a-steps>
        <div class="steps-content flex-1">
          <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
        </div>
        <template class="ant-card-actions" slot="actions">
          <div class="steps-action">
            <a-button-group>
              <a-button v-if="current == 1" type="primary" @click="handleNew" :loading="loadingAdd" :disabled="disabledActionBtnSts">Add</a-button>
            <a-button v-if="current < steps.length - 1" type="default" @click="next" :disabled="disabledActionBtnSts">Next</a-button>
            <a-button
              v-if="type !== 'revised' && current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasiDraft"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save Draft</a-button>
            <a-button
              v-if="current == (steps.length - 1)"
              type="primary"
              :loading="btnLoading"
              @click="validasi"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save</a-button>
            </a-button-group>
            <a-button v-if="current > 0" @click="prev" :disabled="disabledActionBtnSts">Previous</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <a-col :span="rightcolumn" class="m-page-wrapper">
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>Reporting Details</span>
        </div>
        <template slot="extra">
          <!-- <a-button @click="onCollective" class="margin-right-small" icon="edit">Collective</a-button> -->
          <a-button
            @click="handleExpand()"
            :icon="labelExpand == 'Expand' ? 'arrows-alt' : 'shrink'"
          >{{labelExpand}}</a-button>
        </template>
        <a-table
          :columns="columns"
          :dataSource="getCountWeb"
          :pagination="pagination"
          size="small"
          :scroll="{ x: 750 }"
          :loading="loadingtable"
          bordered
        >
          <template slot="type_ticket" slot-scope="text, item">
            <span>{{item.type_ticket}}</span>
          </template>
          <template slot="user_booking" slot-scope="text, item">
            <span>{{item.user_booking}}</span>
          </template>
          <template slot="no_booking" slot-scope="text, item">
            <span>{{item.no_booking}}</span>
          </template>
          <template slot="description" slot-scope="text, item">
            <span>{{item.description}}</span>
          </template>
          <template slot="document" slot-scope="index, item">
            <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
              View Document
            </a>
            <span v-else>
              No File Uploaded
            </span>
          </template>
          
          <template slot="no_sppd" slot-scope="item">
            <b>{{ item.no_sppd ? 'SPPD : '+item.no_sppd : (item.no_pp ? 'PP : '+item.no_pp : '-') }}</b>
          </template>
          <template slot="end_user" slot-scope="text, item">
            <span>{{ item.end_user ? 'Employee : '+item.end_user+" - "+item.nama : (item.nama ? 'Foreigner : '+item.nama : '-') }}</span>
          </template>
          <template slot="operation" slot-scope="index, item">
            <a-button-group v-if="item.credit">
              <a-button type="primary" @click="handleEdit(item)" :loading="loadingEdit">
                <a-icon type="edit" />
              </a-button>
              <a-button type="danger" @click="handleRemoveDetail(item)">
                <a-icon type="close" />
              </a-button>
            </a-button-group>
          </template>

          <template slot="footer">
            <a-row type="flex">
              <a-col :span="7" :order="1" class="m-text-align left">Total Credit</a-col>
              <a-col :span="7" :order="2" class="m-text-align left m-text-bold">
                <CurrencyJustified v-if="kredit" currencyValue="IDR" :valueNumber="kredit" />
              </a-col>
              <a-col :span="3" :order="3" class="m-text-align left m-text-bold"></a-col>
            </a-row>
          </template>
        </a-table>
        <template class="ant-card-actions" slot="actions">
          <div
            class="steps-action"
            v-if="
              current == steps.length - 1 ||
              (mode === 'Edit' && type !== 'draft')
            "
          >
            <a-button
              v-if="current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasi"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save</a-button>
            <a-button
              v-if="type !== 'revised' && current == steps.length - 1"
              type="default"
              :loading="btnLoading"
              @click="validasiDraft"
              :disabled="disableSaveButton || disabledActionBtnSts"
            >Save Draft</a-button>
          </div>
        </template>
      </a-card>
    </a-col>
    <Modal
      v-if="modal.modalEdit"
      :dataList="dataList"
      :data="modal.data"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
    />
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Informasi from "./steps/information.vue";
import Pemakaian from "./steps/usage.vue";
import Approval from "./steps/approval.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import CollectiveKlaimCC from "@/mixins/collective/collectiveKlaimCC";
import nanoid from "nanoid";
import Modal from "./modal.vue";
import moment from "moment";
import Collective from "@/components/collective/Collective.vue";
import Loading from "@/components/preloader/Loading.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "CreateKlaimCreditCard",
  props: ["id", "type"],

  beforeRouteLeave(to, from, next) {
    if (to.path !== from.path) {
      localStorage.removeItem('_temp_id');
    }
    next();
  },

  components: {
    Informasi,
    Pemakaian,
    Approval,
    Modal,
    Collective,
    Loading,
  },
  mixins: [CurrencyFormat, CollectiveKlaimCC, GlobalMethod],
  data() {
    return {
      loading: true,
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Pemakaian",
          content: "Pemakaian",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {},
      mode: "Create",
      id_laporan: "",
      active: false,
      status: false,
      dataList: [],
      url: "",
      debit: 0,
      kredit: 0,
      mata_uang: "",
      sisa_saldo: 0,
      pageLoading: true,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      btnLoading: false,
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          alokasi: "",
          proyek: "",
        },
      },
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingtable: false,
      isCollective: false,
      loadingAdd: false,
      loadingEdit: false,
      EnCommission: true,
      Viwithout_note: true,
      checkAllCollective: false,
      setloading: false,
      disabledActionBtnSts: false,
    };
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER");
    const create_id = localStorage.getItem('_temp_id')
    if(create_id){
      this.id_laporan = create_id
    }else {
      this.id_laporan = nanoid(11);
    }
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
    ]),
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            dataList: this.dataList,
            others: this.collectData.others,
            mode: this.mode,
            type: this.type,
            active: this.active,
            id_laporan: this.id_laporan,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          return {
            data: this.collectData.pemakaian,
            informasi: this.collectData.informasi,
            id_laporan: this.collectData.others.id_laporan
              ? this.collectData.others.id_laporan
              : this.id,
            mode: this.mode,
            dataList: this.dataList,
            debit: this.debit,
            kredit: this.kredit,
            mata_uang: this.mata_uang,
            url: this.url,
            type: this.type,
          };
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            others: this.collectData.others,
            dataList: this.dataList,
            mode: this.mode,
            type: this.type,
            active: this.active,
            id_laporan: this.id,
          };
        } else if (this.steps[this.current].content === "Pemakaian") {
          if (this.type === "draft") {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_laporan: this.id,
              mode: this.mode,
              dataList: this.dataList,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          } else {
            return {
              data: this.collectData.pemakaian,
              informasi: this.collectData.informasi,
              id_laporan: this.id_laporan,
              mode: this.mode,
              dataList: this.dataList,
              debit: this.debit,
              kredit: this.kredit,
              mata_uang: this.mata_uang,
              url: this.url,
            };
          }
        } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            dataList: this.dataList,
            lisAppr: this.collectData.approval,
            id: this.id
          };
        }
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Pemakaian") {
        return "refPemakaian";
      } else{
        return "refApproval";
      }
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 110,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Ticket Type",
          key: "type_ticket",
          width: 150,
          scopedSlots: { customRender: "type_ticket" },
          sorter: (a, b) => a.type_ticket.localeCompare(b.type_ticket),
        },
        {
          title: "User Booking",
          key: "user_booking",
          width: 150,
          scopedSlots: { customRender: "user_booking" },
          sorter: (a, b) => a.user_booking.localeCompare(b.user_booking),
        },
        {
          title: "No Booking",
          key: "no_booking",
          width: 150,
          scopedSlots: { customRender: "no_booking" },
          sorter: (a, b) => a.no_booking.localeCompare(b.no_booking),
        },
        {
          title: "Description",
          key: "deskripsi",
          width: 200,
          scopedSlots: { customRender: "description" },
          sorter: (a, b) => a.deskripsi.localeCompare(b.deskripsi),
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Budget Type",
          key: "no_sppd",
          width: 250,
          scopedSlots: { customRender: "no_sppd" },
          sorter: (a, b) => a.no_sppd.localeCompare(b.no_sppd),
        },
        {
          title: "End User Type",
          key: "end_user",
          width: 250,
          scopedSlots: { customRender: "end_user" },
          sorter: (a, b) => a.end_user.localeCompare(b.end_user),
        },
        {
          title: "Credit",
          dataIndex: "credit",
          key: "credit",
          align: "right",
          width: 170,
          sorter: (a, b) => a.credit.length - b.credit.length,
        },
        {
          // slots: { title: 'customTitle' },
          // this.isCollective ? "Check" : "Action",
          title: "Action",
          scopedSlots: { customRender: "operation" },
          width: this.isCollective ? 90 : 110,
          align: "center",
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.dataList;

      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          data[index]["no"] = index + 1;
          data[index]["key"] = index;

          if (value.credit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.credit
            );
            debit -= value.credit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);

            data[index]["sisa_value"] = debit;
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.expense_date,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
        });
      }
      return data;
    },
    disableSaveButton() {
      let result = this.labelExpand == "Collapse";
      if (result) {
        result = true;
      } else {
        result = this.dataList.length < 1;
      }
      return result;
    },
  },
  methods: {
    moment,
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Pemakaian") {
        if(this.dataList.length<=0){
            this.displayMessageValue(
              "error-other",
              "Data Details can't be empty, because this transaction has at least 1 data!"
            );
        }else{
          let exceedDate = _.filter(this.dataList, item => moment(item.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD'))
          if(exceedDate.length>0){
            this.displayMessageValue("error-other", "Expense date can't exceed today!");
            return;
          }
          this.getApproval();
        }
      }
    },
    prev() {
      if(this.steps[this.current].content === "Approval"){
        this.$refs.refApproval.handleRef();
        this.expandcolumn("collapse");
      }
      this.current--;
    },
    validasi() {
      if (!this.getScreen) {
        this.status = true;
      }
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else {
        this.confirmMessage("confirm-save");
      }
    },
    validasiDraft() {
      this.confirmMessage("confirm-draft");
    },
    validate() {
      this.$refs.refApproval.handleRef();
      this.btnLoading = true;
      // console.log(this.status);
      if (this.status) {
        let postData;
        let method;
        let contentType;
        let link;
        if (this.type === "revised") {
          method = "put";
          contentType = "application/json";
          postData = {
            id_laporan: this.id,
            id_user_cc: this.collectData.informasi.id_user_cc,
            note: this.collectData.informasi.note ? this.collectData.informasi.note : '',
          };
        } else {
          method = "post";
          contentType = "multipart/form-data";
          postData = new FormData();
          
          if (this.mode === "Edit") {
            postData.append("id_laporan", this.collectData.others.id_laporan);            
          } else {
            postData.append("id_laporan", this.id_laporan);
          }
          postData.append("id_user_cc", this.collectData.informasi.id_user_cc);
          postData.append("note", this.collectData.informasi.note ?
            this.collectData.informasi.note : '');
        }
        
        axios({
          method: method,
          url: this.$serviceUrl + "lap_tiket_pd",
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": contentType,
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
            this.displayMessage("success-save");
            this.btnLoading = false;
            if(this.$route.path.includes("/hrd/")){
              this.$router.push({ name: "Spcl_Klaim_Cc_Tiket" });
            }
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (
              response.data.message.includes("Tidak Memiliki Detil Pemakaian")
            ) {
              this.displayMessageValue(
                "error-notif-kaskecil",
                response.data.message
              );
            } else {
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
            }
            this.btnLoading = false;
          });
      } 
      // else {
      //   this.savecatatan();
      // }
    },
    savecatatan(){
      axios({
        method: "post",
        url: this.$serviceUrl + "lap_tiket_pd/draft",
        data: {
          id_laporan : this.id ? this.id : this.id_laporan,
          report_date: moment(this.collectData.informasi.tanggal_pelaporan).format('YYYY-MM-DD'),
          id_user_cc: this.collectData.informasi.id_user_cc,
          note: this.collectData.informasi.note
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then(() => {
        this.displayMessage("success-edit");
        // if(this.$route.path.includes("/keuangan/")){
        //   this.$router.push({ name: "klaimCCKeu" });
        // }else{
        //   this.$router.push({ name: "klaimCC" });
        // }
      }).catch((response) => {
        let responses = Object.assign({}, response.data);
        this.displayMessageValue("error-other",responses);
      });
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        // this.collectData.persetujuan = JSON.parse(
        //   JSON.stringify(value.persetujuan)
        // );
        // if (this.mode === "Edit") {
        //   this.confirmMessage("confirm-edit");
        // } else {
        //   this.confirmMessage("confirm-save");
        // }
        this.current++;
      } else if (this.steps[this.current].content === "Approval"){
        this.collectData.informasi.note = value.note;
      }
    },
    controlForm(value) {
      this.active = value;
    },
    createId(val){
      this.id_laporan = val
      console.log(val);
      
    },
    draftStatus(val) {
      this.status = val;
    },
    async fetchEdit(url) {
      return await new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: url,
          params: {
            id_laporan: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
          this.collectData = {
            informasi: {
              tanggal_pelaporan: response.data.tgl_buat?response.data.tgl_buat:response.data.report_date,
              note: response.data.note,
              jenis_anggaran: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].jns_anggaran_id : null,
              cost_center: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].cost_center_id : null,
              peruntukan: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].peruntukan_id : null,
              activity: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].activity : null,
              type_activity: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].jenis_activity : null,
              pipeline_id: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].pipeline_id: null,
              id_user_cc: response.data.detail_pemakaian ? response.data.detail_pemakaian[0].id_user_cc: null,
            },
            others: {
              mata_uang: response.data.mata_uang,
              id_laporan: response.data.id_laporan,
              total_kredit: response.data.total_kredit,
            },
          };
          this.dataList = response.data.detail_pemakaian
            ? response.data.detail_pemakaian
            : new Array();
          this.loading = false;
          resolve(response);
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
          reject(err);
        });
      });
    },
    fetchPemakaian() {
      let id_laporan;
      this.loadingAdd = true;
      if (this.type === "revised" || this.type === "draft") {
        id_laporan = this.id;
      } else {
        id_laporan = this.id_laporan;
      }
      
      if (!this.getScreen) {
        axios({
          method: "get",
          url: this.url,
          params: {
            tlc: this.getAuth.username,
            id_laporan: id_laporan,
            mode: this.mode,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
          this.dataList = response.data.detail_pemakaian
            ? response.data.detail_pemakaian
            : new Array();
          this.kredit = response.data.total_kredit;
          this.debit = response.data.total_debit;
          this.mata_uang = response.data.mata_uang;
          if (this.dataList.length === 1) {
            this.active = false;
          } 

          if(this.type === "revised"){
            if (response.data.detail_pemakaian.length == 0) {
              this.$router.push({ name: "Spcl_Klaim_Cc_Tiket" });
            }
          }

          this.$refs.refPemakaian.done();
          this.loadingAdd = false;
        }).catch((err) => {
          let response = Object.assign({}, err.response);
          if (response.message === "Tidak Memiliki Detil Pemakaian") {
            this.active = false;
            this.mode = "Create";
            this.dataList = [];
            this.debit = 0;
            this.kredit = 0;

            if (this.type === "draft") {
              this.$router.go(-1);
            }

            this.$refs.refPemakaian.done();

            if (this.mode !== "Create") {
              this.displayMessageValue("error-notif-kaskecil", response.message);
            }
          }
          this.loadingAdd = false;
          this.loading = false;
        });
      } else {
        if (this.steps[this.current].content === "Pemakaian") {
          axios({
            method: "get",
            url: this.url,
            params: {
              tlc: this.getAuth.username,
              id_laporan: id_laporan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.dataList = response.data.detail_pemakaian
                ? response.data.detail_pemakaian
                : new Array();
              this.kredit = response.data.total_kredit;
              this.debit = response.data.total_debit;
              this.mata_uang = response.data.mata_uang;
              this.$refs.refPemakaian.done();
              if (this.dataList.length === 1) {
                this.active = false;
              }
              this.loadingAdd = false;
            })
            .catch((err) => {
              if (
                err.response.data.message === "Tidak Memiliki Detil Pemakaian"
              ) {
                this.active = false;
                this.$refs.refPemakaian.done();
              } 
              this.loading = false;
              this.loadingAdd = false;
            });
        }
      }
    },
    fetchPemakaianAfterUpload(response){
      this.dataList = response.detail_pemakaian
        ? response.detail_pemakaian
        : new Array();
      this.kredit = response.total_kredit;
      this.debit = response.total_debit;
      this.mata_uang = response.mata_uang;
      if (this.dataList.length === 1) {
        this.active = false;
      }
    },
    handleCheckData(e) {
      this.draftStatus(e.target.checked);
    },
    handleNew() {
      this.$refs.refPemakaian.handleNew();
    },
    handleEdit(item) {
      let angcode =
        item.peruntukan_id +
        ";" +
        item.sub_peruntukan_id +
        ";" +
        item.kode_anggaran_id;
      console.log(item);
      
      this.modal.data = {
        path: item.path,
        tanggal_pemakaian: item.tanggal_pemakaian,
        deskripsi: item.description,
        kredit: item.credit,
        id: item.id,
        id_laporan: this.id_laporan,
        id_laporan: item.id_laporan,
        id_sppd: item.id_sppd,
        type: this.type,
        no_sppd: item.no_sppd,
        id_user_cc: item.id_user_cc,
        end_user: item.end_user,
        type_ticket: item.type_ticket,
        no_booking: item.no_booking,
        user_booking: item.user_booking,
        no_pp: item.no_pp,
        nama: item.nama
      };

      if (item.lampiran) {
        this.loadingEdit = true;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.lampiran);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.lampiran_path;
          this.modal.data.doctransfiles = [];
          this.modal.data.doctransfiles.push(file);

          this.modal.modalEdit = true;
          this.loadingEdit = false;
          this.modal.type = this.type;
        })
          .catch((err) => {
          this.loadingEdit = false;
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      } else {
        this.modal.modalEdit = true;
        this.modal.type = this.type;
      }
    },
    handleCancel(e) {
      this.modal.modalEdit = false;
      if (this.$refs.refPemakaian) {
        // this.$refs.refPemakaian.recountingAnggaran(this.dataList);
        // this.$refs.refPemakaian.getTreeAnggaran();
      }
    },
    handleRemoveDetail(item) {
      if (this.dataList.length > 2) {
        this.confirmMessageValue("confirm-delete", item);
      } 
      // else if (this.mode == "Edit" && this.dataList.length == 1) {      
      //   this.displayMessageValue(
      //     "error-other",
      //     "can not delete this data, because this transaction has at least 1 data!"
      //   );
      // } 
      else {
        if (this.type === "draft") {
          this.confirmMessageValue("confirm-delete", item);
        } else {
          this.confirmMessageValue("confirm-delete-clear", item);
        }
      }
    },
    deleteClear(item) {
      this.delete(item);
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      let url = this.type === "revised" ? 
      "lap_tiket_pd/dtl_revisi" : "lap_tiket_pd/dtl_draft";

      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };

      if(this.type == 'revised' && this.dataList.length == 1){
        this.displayMessageValue(
          "error-other",
          "can not delete this data, because this transaction has at least 1 data!"
        );
        return 
      }

      this.loadingtable = true;
      axios({
        method: "delete",
        url: serviceUrl + url,
        processData: false,
        data: {
          id: item.id,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      }).then((response) => {
        this.fetchPemakaian()
        if(this.dataList.length == 1 && this.type == 'draft'){
          this.$router.push({ name: "Spcl_Klaim_Cc_Tiket" });
        }
        this.loadingtable = false;
      })
      .catch((err) => {
        console.log(err);
        this.loadingtable = false;
      });
    },
    switchMode(value) {
      this.mode = value;
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        this.pagination.pageSize = 5;
      }
    },
    fetch() {
      if (this.id) {
        this.mode = "Edit";
        if (this.type === "draft") {
          this.url = this.$serviceUrl + "lap_tiket_pd/dtl_draft";
          this.fetchEdit(this.url)
          .then(()=>{
            //auto set halaman usage ketika sudah ada report detil
            this.current = 1
          });
        } else {
          this.url = this.$serviceUrl + "lap_tiket_pd/dtl_revisi";
          this.fetchEdit(this.url);
        }
      } else if (this.mode === "Create") {
        this.url = this.$serviceUrl + "lap_tiket_pd/dtl_draft";
        this.loading = false;
      }

      if (this.id && this.mode === "Edit" && !this.getScreen && this.loading) {
          this.fetchPemakaian();
      }
    },
    handleLoading(value) {
      this.loadingAdd = value;
    },
    back(){
      if(this.steps[this.current].content=='Approval'){
        this.$refs.refApproval.handleRef();
        this.savecatatan();
        this.$router.go(-1);
      }else{
        this.$router.go(-1);
      }
    },
    async getApproval(){
      let params = {
        tlc : this.getAuth.username,
        tlc_direktur : this.collectData.informasi.no_sppd,
        id_laporan : this.id ? this.id : null,
        is_draft: this.type=='revised' ? 0 : 1,
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "lap_tiket_pd/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.expandcolumn("expand");
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    expandcolumn(val){
      if(val=="expand"){
          this.leftcolumn = 24;
          this.rightcolumn = 0;
      }else{
          this.leftcolumn = 12;
          this.rightcolumn = 12;
      }
    },

    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    onCheckAllChange(val){
      this.getCountWeb.forEach((element) => {
        if(element.edit_hapus!='0'){
          let index = _.findIndex(
            this.selectedTree,
            (e) => {
              return e.id == element.id;
            }
          );

          if(val.target.checked){
            if(index < 0){
              this.selectedTree.push(element)
            }
          }else{
            if(index >= 0){
              this.selectedTree = _.filter(this.selectedTree, (e) => e.id!=element.id)
            }
          }
        }
      })
    },
    triggerActionBtnKlaimCC(val){
      this.disabledActionBtnSts = val
    },
    changeActivity_type(val){
      if(val=="Non Project"){
        this.$nextTick(function () {
          this.formCollective.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.$nextTick(function () {
          this.formCollective.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },

    clearTempId() {
      localStorage.removeItem('_temp_id');
    },
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("klaimTiketInformasi", this.valueFromChild);
    Event.$on("disableInformasi", this.controlForm);
    Event.$on("id_laporan", this.createId);
    Event.$on("draftStatus", this.draftStatus);
    Event.$on("fetchPemakaian", this.fetchPemakaian);
    Event.$on("fetchPemakaianAfterUpload", this.fetchPemakaianAfterUpload);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("removeDetail", this.handleRemoveDetail);
    Event.$on("switchMode", this.switchMode);
    Event.$on("confirmMessageReturn", this.validate);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageDeleteClear", this.deleteClear);
    Event.$on("confirmDraftReturn", this.back)
    Event.$on("handleLoading", this.handleLoading);
    Event.$on("triggerActionBtnKlaimCC", this.triggerActionBtnKlaimCC);
  },
  beforeDestroy() {
    Event.$off("klaimTiketInformasi", this.valueFromChild);
    Event.$off("disableInformasi", this.controlForm);
    Event.$off("draftStatus", this.draftStatus);
    Event.$off("fetchPemakaian", this.fetchPemakaian);
    Event.$off("fetchPemakaianAfterUpload", this.fetchPemakaianAfterUpload);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("removeDetail", this.handleRemoveDetail);
    Event.$off("confirmMessageReturn", this.validate);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageDeleteClear", this.deleteClear);
    Event.$off("confirmDraftReturn", this.back)
    Event.$off("triggerActionBtnKlaimCC", this.triggerActionBtnKlaimCC);
  },
  watch: {
    "this.dataList"(){
      if(this.dataList.length == 0){
        this.$router.push({ name: "Spcl_Klaim_Cc_Tiket" });
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .tree-between {
    display: flex;
    justify-content: space-between;
  }
  .m-text-dots {
    width: 60%;
  }
</style>